
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarTargetTrackedDangerousFilled as ObiRadarTargetTrackedDangerousFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-target-tracked-dangerous-filled.js';
 
 
 

 
 export const ObiRadarTargetTrackedDangerousFilled = createComponent({
   react: React,
   tagName: 'obi-radar-target-tracked-dangerous-filled',
   elementClass: ObiRadarTargetTrackedDangerousFilledElement,
   events: {
     
   }
  });
 
 